import { pgTable, text } from "drizzle-orm/pg-core";
import { id } from "../../utils/sql";
import { unitType } from "../../common/unit/unit.sql";
import type { BodyMetricKey } from "./constants";

export const bodyMetric = pgTable("body_metric", {
  ...id,
  name: text("name").notNull(),
  key: text("key").unique().$type<BodyMetricKey>(),
  unitType: unitType("unit_type").notNull(),
});
